export default class DirtyManager {
	constructor() {
		this.dirtyExtensions = [];
	}

	setDirty(extensionName) {
		if (!this.dirtyExtensions.includes(extensionName)) {
			this.dirtyExtensions.push(extensionName);
		}
	}

	removeDirty(extensionName) {
		if (this.dirtyExtensions.includes(extensionName)) {
			this.dirtyExtensions = this.dirtyExtensions.filter((extension) => extension !== extensionName);
		}
	}

	haveDirtyExtensions() {
		return this.dirtyExtensions.length;
	}
}
